import { IRequest } from '@r1-frontend/shared/types/IRequest';

export interface IRequestDto {
    confirmedEmail: 0 | 1,
    confirmedPhone: 0 | 1,
}

export enum EContactStatuses {
    confirmed = 'confirmed',
    unconfirmed = 'unconfirmed'
}

export interface IContact {
    id: number,
    contactValue: string,
    status: EContactStatuses,
}

export interface IPhone extends IContact {
    phoneTypeId: number,
    needUpdate?: boolean,
}

export interface IContacts {
    email: IContact[],
    phone: IPhone[],
}

export interface IResponseDto {
    contacts: IContacts,
}

/**
 * Вся доступная информация по контактам договора
 * https://master.api-profile.sandbox.d2c.r-one.io/docs/v2#/Info/5bbaf5dc1b84cbb072ce133bea32d418
 */
export const getInfoContacts = ({ confirmedEmail = 1, confirmedPhone = 1 }): IRequest => ({
    uri: '/v2/info/contacts',
    method: 'GET',
    withAuth: true,
    withProvider: true,
    queryParams: {
        confirmedEmail,
        confirmedPhone,
    },
});
